<template>
  <div class="tv">
    <div class="content c895">
      <h2>Dodajte Televizor</h2>
    </div>
    <div class="content c590">
      <div class="popup popDev7" style="display:none;">
        <div class="inner">
          <h3></h3>
          <div class="msg">
            <h3>Izpolniti je potrebno vsaj eno polje za pogostost uporabe naprave!</h3>
          </div>

          <div class="btns">
            <a href="javascript:void(0)" class="btn" title="OK" onclick="popupDelete()">V REDU</a>
          </div>
        </div>
      </div>
      <div class="form">
        <h3>VPIŠITE PODATKE O TELEVIZORJU</h3>
        <div class="f-item select">
          <label>
            Tip televizorja:
            <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
            <span></span>
          </label>
          <select name onchange id>
            <option selected="selected" value="0">Izberite</option>
            <option value="122">LCD</option>
            <option value="123">LED</option>
            <option value="124">Plazma</option>
            <option value="125">CRT</option>
          </select>
        </div>
        <div class="f-item select">
          <label>
            Diagonala zaslona:
            <span
              id
              style="color:Red;float:none;font-size:1em;visibility:hidden;"
            >*</span>
            <span></span>
          </label>
          <select name id>
            <option value="0">Izberite</option>
          </select>
        </div>
      </div>
      <div class="question">
        <p>
          Koliko ur
          <b>na teden</b> uporabljate televizor in kdaj?
        </p>
        <div class="help">
          <a href="#" class="help" title="Help">Help</a>
          <div class="tooltip">
            Na porabo elektrike in višino računa vpliva tarifa, v kateri uporabljate televizor. Manjša tarifa velja med tednom ponoči (od 22.00 do 6.00) ter ob sobotah, nedeljah ter dela prostih dnevih cel dan.
            <p></p>
          </div>
        </div>
      </div>
      <div class="answer-list">
        <ul>
          <li class="first">
            <div>PON-PET, 6:00-22:00</div>
            <div>PON-PET, 22:00-6:00 IN SOB-NED</div>
          </li>
          <li class="answer odd">
            <span class="small">št. ur</span>
            <div>
              <input name type="text" id />
              <span>ur</span>
            </div>
            <div class="last">
              <input name type="text" id />
              <span>ur</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="add">
        <input type="submit" name value="Dodaj" @click="addedApplianceNum(9)" />
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O TELEVIZORJU</h3>
        <p>Trend velikih TV ekranov lahko poveča porabo električne energije za dva krat ali tri krat. Zato bodimo pri nakupu novega TV sprejemnika pozorni na porabo električne energije med funkcijo pripravljenosti (stand by). Posebej ekonomična naprava med funkcijo pripravljenosti porabi le 0,1 W.</p>

        <div class="average">
          <h4>Povprečna poraba tipičnega televizorja na leto</h4>
          <span>250 kWh/leto</span>
          <p>
            <strong>18,87 € / leto</strong> (enotarifno)
            <br />
            <strong>16,18 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    addedApplianceNum(x) {
      console.log('From tv');
      this.$emit('applianceFormClicked', x);
    },
  },
};
</script>

<style>
</style>